import { atom } from "recoil";

import { IRydeProcess, TActiveProcessKey } from "../../models";

export const processAtom = atom<Map<number, IRydeProcess>>({
  key: "processAtom",
  default: new Map(),
});

export const activeProcessesAtom = atom<Map<TActiveProcessKey, number>>({
  key: "activeProcessesAtom",
  default: new Map(),
});
